export function viewFourComplete(state) {
  return {
    ...state,
    designChapter: {
      ...state.designChapter,
      currentView: updateShowFeedback(state.designChapter.currentView),
    },
  };
}

function updateShowFeedback(techniques) {
  return { ...techniques, showFeedback: false };
}
